import React, { useMemo } from "react";
import { isUndefined } from "lodash";

import { Order } from "../../../../../../../services";
import { useAppContext } from "../../../../../../../context";
import { CellContentRoot } from "..";

const ExecutingStageArrivedTimeCellContent: React.FC<
	ExecutingStageArrivedTimeCellContent.Props
> = ({ item }) => {
	const { dateFns } = useAppContext();

	const timestamp = useMemo(
		() => item.executingStages?.arrived?.timestamp,
		[item.executingStages?.arrived?.timestamp],
	);

	const content = useMemo(
		() =>
			isUndefined(timestamp)
				? ""
				: dateFns.formatTime(timestamp, "HH:mm:ss"),
		[dateFns, timestamp],
	);

	return (
		<CellContentRoot alignItems="center" h="100%" w="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace ExecutingStageArrivedTimeCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default ExecutingStageArrivedTimeCellContent;
